import { render } from "./Pet.vue?vue&type=template&id=1a1c572e"
import script from "./Pet.vue?vue&type=script&lang=js"
export * from "./Pet.vue?vue&type=script&lang=js"

import "./Pet.vue?vue&type=style&index=0&id=1a1c572e&lang=css"

import exportComponent from "C:\\Users\\smart\\OneDrive\\Desktop\\Final Projects\\pet-shelter - global\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__